import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

function HeaderLink(props) {
    return (
        <li>
            <Link to={props.routte}>{props.name}</Link>
        </li>
    );
}

export default function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [isNot0Y, setIsNot0Y] = useState(false);
    const { pathname } = useLocation();
    const hamburgerHandle = () => {
        setIsOpen(!isOpen);
        isOpen ? document.body.style.overflowY = 'auto' : document.body.style.overflowY = 'hidden';
    }
    let previousScrollY = window.scrollY;

    const scrollHandle = () => {
        const currentScrollY = window.scrollY;
        if (currentScrollY > previousScrollY || currentScrollY < previousScrollY) setIsNot0Y(currentScrollY > 0);
        previousScrollY = currentScrollY;
    };

    useEffect(() => {
        window.addEventListener("scroll", scrollHandle);
        return () => window.removeEventListener("scroll", scrollHandle);
    }, []);

    useEffect(() => {
        setIsOpen(false);
    }, [pathname]);

    return (
        <header className={pathname !== '/' || isNot0Y ? 'active' : ''}>
            <div className="container">
                <div className="header-body">
                    <div className="logo">
                        <Link to="/">
                            <img src="./img/logo/main.png" alt="" />
                            <h3>YarGoGDPS</h3>
                        </Link>
                    </div>
                    <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={hamburgerHandle}>
                        <span></span>
                    </div>
                    <ul className={`header-list ${isOpen ? 'active' : ''}`}>
                        <HeaderLink routte="/" name="Главная" />
                        <HeaderLink routte="/lists" name="Листы" />
                        <HeaderLink routte="/leaders" name="Слееры" />
                        <li>
                            <a href="https://gofruit.space/gdps/053m" className="dwnl-btn">Скачать</a>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    );
}